import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type Props = {
  errorMessage: string;
};

const AppServerError: React.FC<React.PropsWithChildren<Props>> = ({
  errorMessage,
}) => {
  const { t } = useTranslation();

  return (
    <div className="app-loading-container">
      <Container className="d-flex flex-column align-items-center justify-content-center min-vh-100">
        <div>
          <h4>{t('general.appError')}</h4>
          <div className="text-center">{errorMessage}</div>
        </div>
      </Container>
    </div>
  );
};

export default AppServerError;
